export default __webpack_public_path__ + "static/experiment-adb2cbc5e634d71811f5fdb7bb770833.svg";